jQuery(function($){
    $( document ).ready(function(){
		$('.hp-banner-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 3000,
            pauseOnHover: false
        });
    });
});